<ng-container>
    <div class="mx-5 my-4 branch-details-container">
          @if(isLoading()){
                                                    <app-spinner></app-spinner>
                                                }
        <form [formGroup]="branchDetailsForm">
            <div class="px-2">
                <div class="row mb-5 mt-6">
                    <div class="col-12 col-md-6 form-container mb-6">
                      <label class="form-label form-label-floating mb-3 required" [ngClass]="{'border-danger': branchDetailsForm.get('branchName')?.invalid && branchDetailsForm.get('branchName')?.touched}">Branch Legal Name</label>
                      <input type="text" class="form-control form-control-lg form-control-solid" 
                        [ngClass]="{'border-danger': branchDetailsForm.get('branchName')?.invalid && branchDetailsForm.get('branchName')?.touched}"
                        formControlName="branchName" placeholder="" name="branchName" maxlength="128" />
                      @if (branchDetailsForm.get('branchName')?.invalid && branchDetailsForm.get('branchName')?.touched) {
                        <span class="text-danger">
                            @if (branchDetailsForm.get('branchName')?.errors?.['required']) {
                                Branch Legal Name is required.
                            }
                            @else if (branchDetailsForm.get('branchName')?.errors?.['maxlength']) {
                                Branch Legal Name must be no longer than 128 characters.
                            }
                        </span>
                        }
                    </div>
                  <div class="col-12 col-md-6 form-container">
                    <label class="form-label form-label-floating mb-3 required" [ngClass]="{'border-danger': branchDetailsForm.get('branchCode')?.invalid && branchDetailsForm.get('branchCode')?.touched}">Branch Code</label>
                    <input type="text" class="form-control form-control-lg form-control-solid" 
                    [ngClass]="{'border-danger': branchDetailsForm.get('branchCode')?.invalid && branchDetailsForm.get('branchCode')?.touched}"
                    formControlName="branchCode" placeholder="" name="branchCode" maxlength="64"/>
                    @if (branchDetailsForm.get('branchCode')?.invalid && branchDetailsForm.get('branchCode')?.touched) {
                        <span class="text-danger">
                            @if (branchDetailsForm.get('branchCode')?.errors?.['required']) {
                                Branch Code is required.
                            }
                            @else if (branchDetailsForm.get('branchCode')?.errors?.['pattern']) {
                                Branch Code must be alphanumeric.
                            }
                            @else if (branchDetailsForm.get('branchCode')?.errors?.['maxlength']) {
                                Branch Code must be no longer than 64 characters.
                            }
                        </span>
                    }
                </div>
                </div>
                <div class="row mb-5">
                    <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3 required" [ngClass]="{'border-danger': branchDetailsForm.get('branchCompany')?.invalid && branchDetailsForm.get('branchCompany')?.touched}">Company</label>
                        <select class="form-control form-control-lg form-control-solid" 
                            [ngClass]="{'border-danger': branchDetailsForm.get('branchCompany')?.invalid && branchDetailsForm.get('branchCompany')?.touched}"
                            formControlName="branchCompany" name="branchCompany" (change)="onCompanyChange($event)">
                            <option [value]="null">Select Company</option>
                            <option [value]="company.companyId" *ngFor="let company of this.companyList()">
                                {{company.companyName}}
                            </option>
                        </select>
                        @if (branchDetailsForm.get('branchCompany')?.invalid && branchDetailsForm.get('branchCompany')?.touched) {
                            <span class="text-danger">
                                @if (branchDetailsForm.get('branchCompany')?.errors?.['required']) {
                                    Company is required.
                                }
                            </span>
                        }
                    </div>
                    <div class="col-12 col-md-6 form-container mb-6">
                        <input type="checkbox" class="form-check-input me-2" formControlName="isActive" name="isActive" [value]="1"
                            [checked]="branchDetailsForm.get('isActive')?.value === 1" /> 
                        <label class="form-check-label mt-1 ms-1 text-black">Active</label>
                    </div>
                </div>
                <div class="row mb-5">
                    <h4 class="fw-bold text-gray-900 mb-8">Branch Address</h4>
                    <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3">Unit/Suite Number</label>
                        <input type="text" (keypress)="allowStreetNumberCharacters($event)" class="form-control form-control-lg form-control-solid" 
                            formControlName="unitNum" placeholder="" name="unitNum"/>
                    </div>
                    <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3 required" [ngClass]="{'border-danger': branchDetailsForm.get('streetNum')?.invalid && branchDetailsForm.get('streetNum')?.touched}">Street #</label>
                        <input type="text" (keypress)="allowStreetNumberCharacters($event)" class="form-control form-control-lg form-control-solid" 
                        [ngClass]="{'border-danger': branchDetailsForm.get('streetNum')?.invalid && branchDetailsForm.get('streetNum')?.touched}"
                        formControlName="streetNum" placeholder="" name="streetNum"/>
                        @if (branchDetailsForm.get('streetNum')?.invalid && branchDetailsForm.get('streetNum')?.touched) {
                            <span class="text-danger">
                                @if (branchDetailsForm.get('streetNum')?.errors?.['required']) {
                                    Street num is required.
                                }
                            </span>
                        }
                    </div>
                </div>
                <div class="row mb-5">
                    <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3 required" [ngClass]="{'border-danger': branchDetailsForm.get('streetName')?.invalid && branchDetailsForm.get('streetName')?.touched}">Street name</label>
                        <input type="text" class="form-control form-control-lg form-control-solid" 
                        [ngClass]="{'border-danger': branchDetailsForm.get('streetName')?.invalid && branchDetailsForm.get('streetName')?.touched}"
                        formControlName="streetName" placeholder="" name="streetName"/>
                        @if (branchDetailsForm.get('streetName')?.invalid && branchDetailsForm.get('streetName')?.touched) {
                            <span class="text-danger">
                                @if (branchDetailsForm.get('streetName')?.errors?.['required']) {
                                    Street name is required.
                                }@else if (branchDetailsForm.get('streetName')?.errors?.['pattern']) {
                                    Street name must be integer.
                                }@else if (branchDetailsForm.get('streetName')?.errors?.['maxlength']) {
                                    Street name must be no longer than 128 characters.
                                }
                            </span>
                        }
                    </div>
                    <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3 required" [ngClass]="{'border-danger': branchDetailsForm.get('countryId')?.invalid && branchDetailsForm.get('countryId')?.touched}">Country</label>
                        <select class="form-control form-control-lg form-control-solid" (change)="onCountryChange($event)"
                            [ngClass]="{'border-danger': branchDetailsForm.get('countryId')?.invalid && branchDetailsForm.get('countryId')?.touched}"
                            formControlName="countryId" name="countryId" maxlength="64">
                            <option [value]="null">Select Country</option>
                            <option [value]="country.countryId" *ngFor="let country of countryList()">
                                {{country.countryName}}
                            </option>
                        </select>
                        @if (branchDetailsForm.get('countryId')?.invalid && branchDetailsForm.get('countryId')?.touched) {
                            <span class="text-danger">
                                @if (branchDetailsForm.get('countryId')?.errors?.['required']) {
                                    Country is required.
                                }@else if(branchDetailsForm.get('countryId')?.errors?.['maxlength']){
                                    Country must be no longer than 64 characters.
                                }
                            </span>
                        }
                    </div>
                </div>
                <div class="row mb-5">
                     <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3 required" [ngClass]="{'border-danger': branchDetailsForm.get('zipCode')?.invalid && branchDetailsForm.get('zipCode')?.touched}">Zip code</label>
                        <input type="text" class="form-control form-control-lg form-control-solid" 
                        [ngClass]="{'border-danger': branchDetailsForm.get('zipCode')?.invalid && branchDetailsForm.get('zipCode')?.touched}"
                        formControlName="zipCode" (blur)="onZipCodeBlur()" placeholder="" name="zipCode"/>
                        @if (branchDetailsForm.get('zipCode')?.invalid && branchDetailsForm.get('zipCode')?.touched) {
                            <span class="text-danger">
                                @if (branchDetailsForm.get('zipCode')?.errors?.['required']) {
                                    Zip code is required.
                                }@else if (branchDetailsForm.get('zipCode')?.errors?.['pattern']) {
                                    Invalid Zip Code.
                                }
                            </span>
                        }
                    </div>
                    <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3 required" [ngClass]="{'border-danger': branchDetailsForm.get('stateId')?.invalid && branchDetailsForm.get('stateId')?.touched}">State</label>
                        <mat-select [title]="getStateName(branchDetailsForm.get('stateId')?.value) || ''" class="form-control form-control-lg form-control-solid" formControlName="stateId" name="stateId" (openedChange)="onStateDropdownOpened($event)">
                            <mat-select-trigger>
                                {{getStateName(branchDetailsForm.get('stateId')?.value) || ''}}
                            </mat-select-trigger>
                            <!-- Search input -->
                            <div class="search-container mb-2 mx-2">
                                <input
                                    placeholder="Search..."
                                    [value]="searchState() ? searchState() : ''"
                                    (input)="onStateSearch($event)"
                                    (keydown.space)="$event.stopPropagation()" 
                                    class="form-control form-control-lg form-control-solid"
                                />
                            </div>
                            <div class="option-container pt-4">
                                <!-- Options -->
                                <mat-option *ngFor="let state of filteredStatesList() || []" [value]="state.stateId">
                                    {{ state.stateName }}
                                </mat-option>
                                <!-- No results -->
                                <mat-option *ngIf="filteredStatesList().length === 0" disabled>
                                    No options found
                                </mat-option>
                            </div>
                        </mat-select>
                        @if (branchDetailsForm.get('stateId')?.invalid && branchDetailsForm.get('stateId')?.touched) {
                            <span class="text-danger">
                                @if (branchDetailsForm.get('stateId')?.errors?.['required']) {
                                    State is required.
                                }@else if (branchDetailsForm.get('stateId')?.errors?.['maxlength']) {
                                    State must be no longer than 64 characters.
                                }
                            </span>
                        }
                    </div>

                </div>
                <div class="row mb-5">
                    <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3 required" [ngClass]="{'border-danger': branchDetailsForm.get('cityId')?.invalid && branchDetailsForm.get('cityId')?.touched}">City</label>
                        <mat-select [title]="getCityName(branchDetailsForm.get('cityId')?.value) || ''" class="form-control form-control-lg form-control-solid" formControlName="cityId" name="cityId" (openedChange)="onCityDropdownOpened($event)">
                            <mat-select-trigger>
                                {{ getCityName(branchDetailsForm.get('cityId')?.value) }}
                            </mat-select-trigger>
                            <!-- Search input -->
                            <div class="search-container mb-2 mx-2">
                                <input
                                    placeholder="Search..."
                                    [value]="searchCity() ? searchCity() : ''"
                                    (input)="onCitySearch($event)"
                                    (keydown.space)="$event.stopPropagation()" 
                                    class="form-control form-control-lg form-control-solid"
                                />
                            </div>
                            <div class="option-container pt-4">
                                <!-- Options -->
                                <mat-option *ngFor="let city of filteredCityList() || []" [value]="city.cityId">
                                    {{ city.cityName }}
                                </mat-option>
                                <!-- No results -->
                                <mat-option *ngIf="filteredCityList().length === 0" disabled>
                                    No options found
                                </mat-option>
                            </div>
                        </mat-select>
                        @if (branchDetailsForm.get('cityId')?.invalid && branchDetailsForm.get('cityId')?.touched) {
                            <span class="text-danger">
                                @if (branchDetailsForm.get('cityId')?.errors?.['required']) {
                                    City is required.
                                }@else if (branchDetailsForm.get('cityId')?.errors?.['maxlength']) {
                                    City must be no longer than 64 characters.
                                }
                            </span>
                        }
                    </div>
                    <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3 required" [ngClass]="{'border-danger': branchDetailsForm.get('countyId')?.invalid && branchDetailsForm.get('countyId')?.touched}">County</label>
                        <mat-select [title]="getCountyName(branchDetailsForm.get('countyId')?.value) || ''" class="form-control form-control-lg form-control-solid" formControlName="countyId" name="countyId" (openedChange)="onCountyDropdownOpened($event)">
                            <mat-select-trigger>
                                {{ getCountyName(branchDetailsForm.get('countyId')?.value) }}
                            </mat-select-trigger>
                            <!-- Search input -->
                            <div class="search-container mb-2 mx-2">
                                <input
                                    placeholder="Search..."
                                    [value]="searchCounty() ? searchCounty() : ''"
                                    (input)="onCountySearch($event)"
                                    (keydown.space)="$event.stopPropagation()" 
                                    class="form-control form-control-lg form-control-solid"
                                />
                            </div>
                            <div class="option-container pt-4">
                                <!-- Options -->
                                <mat-option *ngFor="let county of filteredCountyList() || []" [value]="county.countyId">
                                    {{ county.countyName }}
                                </mat-option>
                                <!-- No results -->
                                <mat-option *ngIf="filteredCountyList().length === 0" disabled>
                                    No options found
                                </mat-option>
                            </div>
                        </mat-select>
                        @if (branchDetailsForm.get('countyId')?.invalid && branchDetailsForm.get('countyId')?.touched) {
                            <span class="text-danger">
                                @if (branchDetailsForm.get('countyId')?.errors?.['required']) {
                                    County is required.
                                }@else if (branchDetailsForm.get('countyId')?.errors?.['maxlength']) {
                                    County must be no longer than 64 characters.
                                }
                            </span>
                        }
                    </div>                   
                </div>
                <div class="row mb-5">
                    <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3 required" [ngClass]="{'border-danger': branchDetailsForm.get('branchPhone')?.invalid && branchDetailsForm.get('branchPhone')?.touched}">Branch Phone Number</label>
                        <ngx-intl-tel-input
                            [cssClass]="'form-control form-control-lg form-control-solid'"
                            [preferredCountries]="[CountryISO.UnitedStates, CountryISO.UnitedKingdom]"
                            [enableAutoCountrySelect]="false"
                            [enablePlaceholder]="false"
                            [searchCountryFlag]="true"
                            [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                            [searchCountryPlaceholder]="'Search...'"
                            [selectFirstCountry]="false"
                            [selectedCountryISO]="branchDetailsForm.get('branchPhoneCountryCode')?.value || CountryISO.UnitedStates"
                            [maxLength]="getMaxPhoneLength(branchDetailsForm.get('branchPhoneCountryCode')?.value)"
                            [phoneValidation]="false"
                            [separateDialCode]="true"
                            formControlName="branchPhone"
                            name="branchPhone"
                            (countryChange)="onBranchPhoneCountryChange($event)">
                        </ngx-intl-tel-input>
                        @if (branchDetailsForm.get('branchPhone')?.invalid && branchDetailsForm.get('branchPhone')?.touched) {
                            <span class="text-danger">
                                @if (branchDetailsForm.get('branchPhone')?.errors?.['required']) {
                                    Branch Phone Number is required.
                                }@else if (branchDetailsForm.get('branchPhone')?.errors?.['pattern'] || branchDetailsForm.get('branchPhone')?.errors?.['validatePhoneNumber']) {
                                    Please enter a valid Phone Number.
                                }
                            </span>
                        }
                    </div>
                    <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3 required" [ngClass]="{'border-danger': branchDetailsForm.get('branchEmail')?.invalid && branchDetailsForm.get('branchEmail')?.touched}">Branch Email</label>
                        <input type="text" class="form-control form-control-lg form-control-solid" 
                        [ngClass]="{'border-danger': branchDetailsForm.get('branchEmail')?.invalid && branchDetailsForm.get('branchEmail')?.touched}"
                        formControlName="branchEmail" placeholder="" name="branchEmail"/>
                        @if (branchDetailsForm.get('branchEmail')?.invalid && branchDetailsForm.get('branchEmail')?.touched) {
                            <span class="text-danger">
                                @if (branchDetailsForm.get('branchEmail')?.errors?.['required']) {
                                    Branch Email is required.
                                }@else if (branchDetailsForm.get('branchEmail')?.errors?.['pattern']) {
                                    Please enter a valid email address.
                                }
                            </span>
                        }
                    </div>
                </div>                               
          </div>
        </form>
    </div>
    <mat-action-row class="accordion-footer d-flex justify-content-end py-5 px-6">
        <button mat-button type="button" (click)="onCancel()"  class="btn btn-lg btn-light-primary me-3 back-btn">Cancel</button>
        <div [attr.title]="this.branchDetailsForm.invalid ? 'Please fix the errors in the form.' : null">
            <button mat-button type="submit" (click)="onSubmit()"  [disabled]="this.branchDetailsForm.invalid" class="btn btn-lg btn-primary continue-btn">{{ isCreateBranch ? 'Create' : 'Save' }}</button>                                                      
        </div>
    </mat-action-row> 
</ng-container>